import { Button, Tag, Flex, FormControl, FormErrorMessage, FormLabel, Heading, Input, Link, Select, Box } from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import DoencaService from "../../../main/services/DoencaService";
import { Link as ReactLink, useHistory } from 'react-router-dom';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { doencaFunc } from '../../../helpers/Funcionalidades'
import { Group } from '../Criancas/Group';


const RegistrarDoenca = () => {

    document.title = 'MCA - Doenças - Cadastrar'
    let history = useHistory();

    const { roleKeycloack } = useAuthProvider();
    const [descricaoCount, setDescricaoCount] = useState(0);

    const validate = (values) => {
        const errors = {};

        if (!values.descricao || values.descricao === "") {
            errors.descricao = "Descrição é obrigatória!";
        }

        if (!values.dispensaLaudo || values.dispensaLaudo === "") {
            errors.dispensaLaudo = "Dispensa laudo é obrigatório!";
        }

        return errors;
    };

    return roleKeycloack && roleKeycloack.includes(doencaFunc.doencaCadastrar) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize="large">
                    Cadastrar Doença
                </Heading>
                <Link as={ReactLink}
                    to="/doenca/lista"
                    _hover={{ textDecoration: "none" }}
                >
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>

            <Formik
                validate={validate}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    descricao: ""
                }}
                onSubmit={(values,
                    { setSubmitting, setFieldError }) => {
                    setTimeout(() => {
                        DoencaService.novoDoenca(values).then((res) => {
                            Swal.fire({
                                title: 'Sucesso!',
                                'text': 'Registro cadastrado com sucesso!',
                                icon: 'success',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: '#169499'
                            }).then(function () {
                                history.push("/doenca/" + res.data.id)
                            });

                            setSubmitting(false);
                        }).catch((error => {
                            setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                            setSubmitting(false);
                        }))

                    }, 200)
                }}>
                {(props) => (
                    <Flex
                        flexDir="column"
                        mt={5}>
                        <Form>
                            <Flex>
                                <Group bgColor="#fff" title="" py="12px" >
                                    <Box width={{ lg: '50%' }}>
                                        <Field name="descricao">
                                            {({ field, form }) => (
                                                <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                    <FormLabel htmlFor="descricao">Descrição*</FormLabel>
                                                    <Input
                                                        h="42px"
                                                        autoFocus
                                                        backgroundColor="white"
                                                        {...field} id="descricao"
                                                        placeholder="Informe a Descrição da Doença"
                                                        maxLength={255}
                                                        onChange={(e) => {
                                                            setDescricaoCount(e.target.value.length);
                                                            form.setFieldValue(field.name, e.target.value);
                                                        }}
                                                    />
                                                    <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                </FormControl>

                                            )}
                                        </Field>

                                        <Flex flexDirection="row-reverse">
                                            <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                        </Flex>

                                        <Flex mt={5}>
                                            <Field name="dispensaLaudo">
                                                {({ field, form }) => (
                                                    <FormControl isInvalid={form.errors.dispensaLaudo}>
                                                        <FormLabel htmlFor="dispensaLaudo">Dispensa Laudo Médico para Efeitos do QUF/MPRJ?*</FormLabel>
                                                        <Select
                                                            {...field}
                                                            id="tipo"
                                                            backgroundColor={"white"}
                                                            placeholder={"Selecione"}
                                                            h="42px"
                                                        >
                                                            <option value={"S"}>Sim</option>
                                                            <option value={"N"}>Não</option>
                                                        </Select>
                                                        <FormErrorMessage>{form.errors.dispensaLaudo}</FormErrorMessage>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </Flex>
                                    </Box>
                                </Group>
                            </Flex>
                            <Flex mt={2} justifyContent="space-between">
                                <Flex></Flex>
                                <Button
                                    mt={4}
                                    colorScheme="teal"
                                    px={16}
                                    isLoading={props.isSubmitting}
                                    type="submit"
                                    translate="no">
                                    Salvar
                                </Button>
                            </Flex>

                        </Form>
                    </Flex>
                )}
            </Formik>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    )
}

export default RegistrarDoenca;